import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";

export default function Manifesto() {
  const content = useContent();
  const m = content.manifesto;
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative bg-obsidian py-24 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-gold"
        >
          {m.eyebrow}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-6 max-w-3xl font-display text-3xl font-bold tracking-tight text-zinc-100 sm:text-4xl lg:text-5xl"
        >
          {m.titlePre} <span className="text-gold">{m.titleGold}</span> {m.titlePost}
        </motion.h2>

        <div className="mt-16 sm:mt-24">
          {m.chapters.map((c, i) => (
            <motion.div
              key={c.no}
              data-testid={`manifesto-chapter-${c.no}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, delay: 0.08 * i, ease: [0.33, 1, 0.68, 1] }}
              className="group grid grid-cols-1 gap-6 border-t border-gold/15 py-12 transition-colors duration-500 hover:border-gold/40 sm:grid-cols-[120px_1fr_1.2fr] sm:gap-12 lg:py-16"
            >
              <span className="font-display text-6xl font-extrabold text-outline-gold transition-colors duration-500 group-hover:text-gold group-hover:[-webkit-text-stroke:0px] lg:text-7xl">
                {c.no}
              </span>
              <h3 className="font-display text-2xl font-bold text-zinc-100 sm:text-3xl">{c.title}</h3>
              <p className="max-w-xl text-sm leading-relaxed text-zinc-400 sm:text-base">{c.copy}</p>
            </motion.div>
          ))}
          <div className="border-t border-gold/15" />
        </div>
      </div>
    </section>
  );
}
